import { Trans } from 'react-i18next';
import {
    convertMapToList,
    DEFAULT_STATUS_KEY,
    EntityStatusInfo,
    StatusInfo,
} from 'src/components/EntityStatusInfo/EntityStatusInfo';
import { LegalEntityDto } from 'src/generated-api-client';
import { CssColors } from 'src/styles/CssVariables';

export enum BorrowerStatusKey {
    HIGH_RISK = 'HIGH_RISK',
    BLACKLISTED = 'BLACKLISTED',
}

type BorrowerStatusProps = {
    borrower: LegalEntityDto;
};

export const BorrowerStatus = ({ borrower }: BorrowerStatusProps) => {
    return (
        <>
            {borrower.highRisk && (
                <EntityStatusInfo
                    statusInfoMap={borrowerStatusInfoMap}
                    status={BorrowerStatusKey.HIGH_RISK}
                    entityName="borrower"
                />
            )}
            {borrower.blacklisted && (
                <EntityStatusInfo
                    statusInfoMap={borrowerStatusInfoMap}
                    status={BorrowerStatusKey.BLACKLISTED}
                    entityName="borrower"
                />
            )}
        </>
    );
};

const borrowerStatusInfoMap: Record<string, StatusInfo> = {
    [BorrowerStatusKey.HIGH_RISK]: {
        color: CssColors.mainRed,
        borderColor: CssColors.mainRed,
        title: <Trans i18nKey="data:status.borrower.HIGH_RISK" />,
        backgroundColor: CssColors.mainRed,
    },
    [BorrowerStatusKey.BLACKLISTED]: {
        color: CssColors.mainRed,
        borderColor: CssColors.mainRed,
        title: <Trans i18nKey="data:status.borrower.BLACKLISTED" />,
        backgroundColor: CssColors.mainRed,
    },
    [DEFAULT_STATUS_KEY]: {
        color: CssColors.mainGray,
        borderColor: CssColors.mainGray,
        title: '',
        backgroundColor: CssColors.mainGray,
    },
};

export const getBorrowerStatuses = () => {
    return convertMapToList(borrowerStatusInfoMap);
};
